import { render, staticRenderFns } from "./ProfileTabDossier.vue?vue&type=template&id=469ac6f2&scoped=true"
import script from "./ProfileTabDossier.vue?vue&type=script&lang=js"
export * from "./ProfileTabDossier.vue?vue&type=script&lang=js"
import style0 from "./ProfileTabDossier.vue?vue&type=style&index=0&id=469ac6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469ac6f2",
  null
  
)

export default component.exports